/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Vehicle Grades Carousel directive options
 */
export const vehicleGradesCarouselOptions = {
  /**
   * CSS selectors for various elements
   */
  selectors: {
    // Main elements
    slider: '.vehicle-grades-carousel__slider',
    emptyState: '.js-filter-empty-state',
    card: '.vehicle-grades-carousel__card',
    cardImage: '.vehicle-grades-carousel__card-image--default',
    cardHoverImage: '.vehicle-grades-carousel__card-image--hover',
    cardPrice: '.vehicle-grades-carousel__card-price',
    variantDesc: '.js-variant-desc',
    buildPriceCta: '.js-build-price-cta',

    // Color swatches
    colorSwatchers: '.vehicle-grades-carousel__card-color-switchers',
    colorSwatch: '.js-color-swatch',

    // Desktop filter
    filterPill: '.vehicle-grades-carousel__filter-pill',
    filterReset: '.js-filter-reset',

    // Mobile filter sheet
    filterSheet: '.js-filter-sheet',
    filterSheetOpen: '.js-open-filter-sheet',
    filterSheetClose: '.js-filter-sheet-close',
    filterSheetApply: '.js-filter-sheet-apply',
    filterSheetReset: '.js-filter-sheet-reset',
    filterSheetSection: '.vehicle-grades-carousel__filter-sheet-section',
    filterSheetOption: '.vehicle-grades-carousel__filter-sheet-option',

    // Features sheet
    featuresSheet: '.js-features-sheet',
    featuresSheetOpen: '.js-open-features-sheet',
    featuresSheetClose: '.js-features-sheet-close',
    featuresSpecDownload: '.js-features-spec-download',

    // Accordion
    accordionToggle: '.js-accordion-toggle',

    // Navigation
    chevronPrev: '.js-carousel-prev',
    chevronNext: '.js-carousel-next',

    // Grades count
    gradesCount: '.vehicle-grades-carousel__grades-count'
  },

  /**
   * Filter categories for OR within category, AND across categories logic
   */
  filterCategories: {
    seats: ['5 Seats', '7 Seats'],
    fuelType: ['Hybrid', 'Petrol'],
    interior: ['Fabric', 'Leather']
  },

  /**
   * Chevron colors
   */
  chevronColorEnabled: '#0A0A0A',
  chevronColorDisabled: '#C8C8C8'
};
